// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-ySx","colBig":"styles_colBig__2v3hy","colSmall":"styles_colSmall__X3af1"};